<template>
  <section
    class="physical-home-document-item-container"
    @click="handleToDetail(item)"
  >
    <div class="item-content">
      <img class="item-img" :src="item.our_pic_url" alt="" />
      <div class="inner">
        <!-- 顶部 -->
        <div>
          <div class="product-title">
            <img
              class="logo_img"
              :src="sourceList[item.source] || sourceList[2]"
              alt=""
            />
            <p>{{ item.title }}</p>
          </div>
          <div class="buble-group" v-if="item.coupon">
            <div class="juan_box">
              <img class="juan_img" src="../imgs/icon_juan.png" />
              <div class="box">¥{{ item.coupon }}</div>
            </div>
          </div>
        </div>
        <!-- 底部 -->
        <div>
          <div class="subtitle">
            <p class="after-discount">
              券后:¥
              <span>
                <nr-amount
                  :value="item.final_price"
                  has-separator
                  class="number"
                />
              </span>
            </p>
          </div>
          <div class="chat">
            <p>
              佣金:<span>
                {{
                  round(
                    (item.source === "2" || item.source === "4"
                      ? item.channel_media_distribution_proportion
                      : item.final_media_distribution_proportion) * 100
                  )
                }}
              </span>
              %
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { round } from "@/utils";
// 引入logo
import taobao_logo from "@/assets/imgs/icon_taobao.svg";
import jd_logo from "@/assets/imgs/icon_jd.svg";
import youzan_logo from "@/assets/imgs/icon_youzan.svg";
// import pdd_logo from "@/assets/imgs/icon_pdd.svg";
export default {
  props: {
    item: {
      type: Object,
      default: {},
    },
    /*
    照片 - our_pic_url
    标题 - title
    优惠卷 - coupon
    卷后价 - final_price
    分佣比例 - channel_media_distribution_proportion || final_media_distribution_proportion
    */
  },
  data() {
    return {
      // 渠道
      sourceList: [
        0, // 占位
        youzan_logo, //source = 1, 有赞
        taobao_logo, //source = 2, 淘宝
        jd_logo, //source = 3, 京东
        taobao_logo, //source = 4, 淘宝
        // pdd_logo, //source = 5, 拼多多
      ],
    };
  },
  methods: {
    round,
    //去详情
    handleToDetail(item) {
      if (!this.isNewWindow) {
        this.$router.push({
          name: "physicalDetail",
          params: {
            id: item.alias,
          },
          query: {
            category: item.our_category_id,
            _internal_: "document",
          },
        });
      } else {
        let { href } = this.$router.resolve({
          name: "physicalDetail",
          params: {
            id: item.alias,
          },
          query: {
            category: item.our_category_id,
            _internal_: "document",
          },
        });
        let newWindow = window.open("_blank");
        newWindow.location = href;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.physical-home-document-item-container {
  box-sizing: border-box;
  padding: 32px 16px 0;
  width: 370px;
  height: 540px;
  .item-content {
    // width: 252px;
    border: 2px solid #e1e1e6;
    border-radius: 16px;
    overflow: hidden;

    .item-img {
      background: #cacaca;
      width: 100%;
      height: 300px;
    }

    .inner {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 210px;
    }
    .product-title {
      box-sizing: border-box;
      margin-top: 10px;
      padding: 0 16px;
      display: flex;
      align-items: center;
      .logo_img {
        margin-right: 6px;
        width: 28px;
        height: 28px;
      }
      p {
        width: 272px;
        font-size: 28px;
        line-height: 42px;
        color: #3e4040;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .buble-group {
      margin-top: 10px;
      padding: 0 16px;
      .juan_box {
        display: flex;
        .juan_img {
          width: 36px;
          height: 32px;
        }
        .box {
          padding: 0 10px 0 5px;
          min-width: 40px;
          height: 32px;
          line-height: 1.8;
          background: url("../imgs/icon_juan_box.png");
          background-size: 100% 100%;
          font-size: 20px;
          color: #ff7733;
        }
      }
    }
    .subtitle {
      margin-top: 10px;
      padding: 0 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .after-discount {
        font-size: 22px;
        line-height: 30px;
        color: #ff7733;
        span {
          font-size: 28px;
          font-weight: bold;
          line-height: 44px;
          color: #ff7733;
        }
      }
    }
    .chat {
      margin-top: 8px;
      padding: 0 16px;
      // width: 252px;
      height: 50px;
      background: #ff7733;
      
      p {
        font-size: 22px;
        color: #ffffff;

        span {
          font-size: 28px;
          font-weight: bold;
          line-height: 44px;
        }
      }
    }
  }
}
</style>
